import type { NodeDefinition } from '../../types';
import { t, r } from '../../rubyParts';
import { pickRandomIndex } from '../../randomSelection';
import { RandomChoiceNodeView } from '../views/RandomChoiceNode';
import { RandomChoiceSettings } from '../settings/RandomChoiceSettings';

const MAX_CHOICE_LENGTH = 200;

export const randomChoiceDefinition: NodeDefinition<'randomChoice'> = {
  label: 'Random Choice',
  showInPalette: true,
  paletteColor: 'bg-red-100 border-red-500 text-red-700',
  miniMapColor: '#ef4444',
  defaultData: {
    label: 'Random Choice',
    choice1: 'A',
    choice2: 'B',
    choice3: 'C',
  },
  view: RandomChoiceNodeView,
  settings: RandomChoiceSettings,
  run: (node, ctx, log) => {
    const choices = [
      node.data.choice1 ?? 'A',
      node.data.choice2 ?? 'B',
      node.data.choice3 ?? 'C',
    ];
    if (choices.some((choice) => typeof choice !== 'string' || choice.trim() === '')) {
      log('[Random Choice] エラー: 3つの候補をすべて入力してください');
      return { nextHandle: null };
    }
    if (choices.some((choice) => [...choice].length > MAX_CHOICE_LENGTH)) {
      log(`[Random Choice] エラー: 候補は${MAX_CHOICE_LENGTH}文字以内にしてください`);
      return { nextHandle: null };
    }

    const selected = choices[pickRandomIndex(choices.length, ctx.random ?? Math.random)];
    ctx.lastValue = selected;
    log(`[Random Choice] 「${selected}」を選びました`);
  },
  help: {
    title: [t('Random Choice（くじびき）')],
    description: [
      t('3つの'),
      r('候補', 'こうほ'),
      t('から、くじびきのように1つがランダムに'),
      r('選', 'えら'),
      t('ばれます。'),
      r('選', 'えら'),
      t('ばれた「ことば」は、つぎのカードに'),
      r('渡', 'わた'),
      t('されます。'),
    ],
  },
};
